import { useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useLogin() {
  const login = useCallback((credentials) => quarkusApi.post('/login', credentials), []);

  return { login };
}
